export default __webpack_public_path__ + "images/b3324ad2d50795c68a08944d01c063e7.png";